// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7f77f7fe","453":"d855a71b","455":"7a1678c0"}[chunkId] + ".chunk.js";
};